// 简体中文
export default {
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '信息',
    submit: '提交',
    close: '关闭',
    search: '搜索',
    more: '更多',
    empty: '暂无数据',
    yuan: '元'
  },

  // 导航
  nav: {
    home: '首页',
    market: '行情',
    mall: '商城',
    mine: '我的',
    account: '账户'
  },

  // 登录相关
  login: {
    title: '登录',
    account: '账号',
    password: '密码',
    code: '验证码',
    sendCode: '发送验证码',
    login: '登陆',
    register: '注册',
    forgetPassword: '忘记密码',
    accountRequired: '请输入账号',
    passwordRequired: '请输入密码',
    codeRequired: '请输入验证码',
    noAccount: '还没有账号？',
    openAccount: '马上开户',
    contactService: '忘记密码请联系客服！',
    loginSuccess: '登陆成功!',
    loginFailed: '登录失败',
    onlineService: '在线客服',
    forgetPasswordTip: '忘记密码',
    username: '用户名'
  },

  // 首页
  index: {
    title: '首页',
    quickRecharge: '快捷充值',
    rechargeDesc: '银行转账和多种方式选择',
    market: '交易',
    closed: '休市',
    welcome: '欢迎使用本平台！实时行情更新，安全便捷交易，祝您交易愉快！'
  },

  // 实名认证
  verified: {
    title: '实名认证',
    name: '姓名',
    idcard: '身份证号',
    nameError: '名字不正确',
    nameRequired: '请填写姓名',
    idcardRequired: '请填写身份证号',
    frontCardRequired: '请上传身份证正面',
    backCardRequired: '请上传身份证背面',
    submit: '确认',
    status0: '未认证',
    status1: '审核中',
    status2: '已认证'
  },

  // 用户相关
  user: {
    profile: '个人资料',
    account: '账户',
    settings: '设置',
    logout: '退出登录',
    balance: '余额',
    assets: '资产',
    history: '历史记录',
    myInfo: '我的信息',
    realName: '实名认证',
    bankCard: '银行卡',
    alipay: '支付宝',
    phone: '手机号',
    email: '邮箱',
    name: '姓名'
  },

  // 交易相关
  trade: {
    title: '交易',
    buy: '买入',
    sell: '卖出',
    price: '价格',
    quantity: '数量',
    total: '总额',
    confirm: '确认交易',
    cancel: '取消交易',
    orderPlaced: '订单已提交',
    orderFailed: '订单提交失败',
    insufficientBalance: '余额不足',
    priceRequired: '请输入价格',
    quantityRequired: '请输入数量',
    volume: '成交量',
    highest: '最高',
    lowest: '最低',
    open: '今开',
    position: '持仓',
    kline: 'K线',
    fluctuation: '波动',
    time1m: '1分',
    time5m: '5分',
    time15m: '15分',
    time30m: '30分',
    time1h: '1小时',
    time1d: '一天',
    enterInvestAmount: '请输入投资金额'
  },

  // 行情相关
  market: {
    title: '行情',
    price: '价格',
    change: '涨跌',
    volume: '成交量',
    high: '最高',
    low: '最低',
    open: '开盘',
    close: '收盘',
    upTrend: '上升',
    downTrend: '下降'
  },

  // 商城相关
  mall: {
    title: '商城',
    goods: '商品',
    cart: '购物车',
    order: '订单',
    price: '价格',
    quantity: '数量',
    buy: '购买',
    addCart: '加入购物车',
    checkout: '结算',
    myOrders: '我的订单'
  },

  // 充值相关
  recharge: {
    title: '充值',
    amount: '充值金额',
    method: '充值方式',
    bankTransfer: '银行转账',
    alipay: '支付宝',
    wechat: '微信',
    rechargeSuccess: '充值成功',
    copied: '复制成功',
    copiedSuccess: '已复制',
    rechargeFailed: '充值失败',
    amountRequired: '请输入充值金额',
    methodRequired: '请选择充值方式',
    rechargeRecord: '充值记录'
  },

  // 提现相关
  cash: {
    title: '提现',
    amount: '提现金额',
    method: '提现方式',
    bankCard: '银行卡',
    alipay: '支付宝',
    cashSuccess: '提现申请已提交',
    cashFailed: '提现失败',
    amountRequired: '请输入提现金额',
    methodRequired: '请选择提现方式',
    cashRecord: '提现记录',
    addBankCard: '添加银行卡',
    addAlipay: '添加支付宝'
  },

  // 消息相关
  message: {
    title: '消息',
    noMessage: '暂无消息',
    markRead: '标记为已读',
    delete: '删除',
    news: '新闻',
    notification: '通知',
    system: '系统消息'
  },

  // 错误提示
  error: {
    networkError: '网络错误',
    serverError: '服务器错误',
    notFound: '未找到',
    unauthorized: '未授权',
    forbidden: '禁止访问',
    timeout: '请求超时',
    paramError: '参数错误',
    dataError: '数据错误',
    requestFailed: '请求失败',
    networkErrorRetry: '网络错误，请稍后重试'
  },

  // 账户相关
  account: {
    title: '账户',
    totalAssets: '总资产',
    availableBalance: '可用余额',
    frozenBalance: '冻结余额',
    tradingAccount: '交易账户',
    fundAccount: '资金账户',
    accountInfo: '账户信息',
    accountSecurity: '账户安全',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    passwordChanged: '密码修改成功'
  },

  // 帮助相关
  help: {
    title: '帮助中心',
    faq: '常见问题',
    tutorial: '使用教程',
    contact: '联系我们',
    feedback: '意见反馈',
    about: '关于我们',
    howRecharge: '如何充值？',
    rechargeAnswer: '请联系在线客服获取充值信息',
    howWithdraw: '如何提现？',
    withdrawAnswer: '在账户页面点击提现申请，填写相关信息即可',
    forgetPwd: '忘记密码怎么办？',
    forgetPwdAnswer: '请联系在线客服协助找回密码',
    modifyCard: '如何修改银行卡？',
    modifyCardAnswer: '请联系在线客服协助修改银行卡信息'
  },

  // 我的页面
  mine: {
    title: '我的',
    myInfo: '我的信息',
    realName: '实名认证',
    bankCard: '银行卡',
    alipay: '支付宝',
    accountSecurity: '账户安全',
    logout: '退出登录',
    creditScore: '信用积分',
    recommendCode: '推荐码',
    level: '等级',
    copySuccess: '复制成功',
    phone: '手机号',
    name: '姓名',
    notVerified: '未认证',
    verifying: '审核中',
    verified: '已认证',
    news: '新闻资讯',
    passwordModify: '密码修改',
    bindingInfo: '绑定信息',
    onlineService: '在线客服',
    tradingRules: '交易规则',
    aboutUs: '关于我们',
    recommendIdCopied: '推荐ID已复制',
    notObtained: '未获取'
  },

  // 充值详情
  rechargeDetail: {
    title: '充值',
    tip: '温馨提示：点击收款账号和姓名可复制其内容',
    bankName: '开户银行',
    bankBranch: '开户网点',
    accountNumber: '收款账号',
    accountName: '收款姓名',
    contactService: '联系在线客服',
    amount: '充值金额',
    depositorName: '存款姓名',
    transferRemark: '转账附言',
    submit: '充值',
    copied: '已复制'
  },

  // 提现详情
  cashDetail: {
    title: '提现',
    availableAmount: '可提现金额（元）',
    withdrawAmount: '提现金额',
    fee: '手续费',
    minAmount: '单次提现金额最低',
    password: '提现密码',
    bankCard: '提现账户',
    submit: '确认提交',
    hint: '提示',
    limit: '提现限制',
    time: '提现时间',
    forgetPwd: '若忘记提现密码，请',
    retrieve: '点击找回',
    record: '提现记录',
    withdrawal: '提现',
    pending: '审核中',
    rejected: '已拒绝',
    completed: '已到账',
    arrived: '已到账',
    refused: '已拒绝',
    reviewing: '审核中'
  },

  // 银行卡相关
  bankCard: {
    title: '银行卡管理',
    addBank: '添加银行卡',
    bindAlipay: '绑定支付宝',
    bindWallet: '绑定钱包地址',
    walletAddress: '钱包地址',
    walletSection: '钱包地址',
    enterWalletAddress: '请输入钱包地址',
    cardholderName: '持卡人',
    cardNumber: '银行卡号',
    bankName: '开户银行',
    bankBranch: '开户支行',
    submit: '确认添加',
    realName: '真实姓名',
    alipayAccount: '支付宝账号',
    bindSubmit: '确认绑定',
    alipaySection: '支付宝账号',
    enterCardholderName: '请输入持卡人姓名',
    enterCardNumber: '请输入银行卡号',
    enterBankName: '请输入开户银行',
    enterRealName: '请输入真实姓名',
    enterAlipayAccount: '请输入支付宝账号',
    contactService: '修改银行卡请联系在线客服'
  },

  // 密码相关
  password: {
    modifyLogin: '修改登录密码',
    modifyPay: '修改支付密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    payPassword: '支付密码',
    confirmPayPassword: '确认支付密码',
    submit: '确认修改',
    enterOldPwd: '请输入原密码',
    enterNewPwd: '请输入新密码',
    enterConfirmPwd: '请再次输入新密码',
    passwordMismatch: '两次密码不一致'
  },

  // 账单相关
  bill: {
    title: '账单',
    fundChange: '资金变动',
    noRecord: '暂无记录',
    income: '收入',
    expense: '支出'
  },

  // 新闻相关
  news: {
    title: '新闻资讯',
    detail: '新闻详情',
    noNews: '暂无新闻',
    tradeRules: '交易规则',
    aboutUs: '关于我们'
  },

  // 交易详情
  tradeDetail: {
    buyRise: '买涨',
    buyFall: '买跌',
    highest: '最高',
    lowest: '最低',
    open: '今开',
    position: '持仓',
    volume: '成交量',
    kline: 'K线',
    fluctuation: '波动',
    time1m: '1分',
    time5m: '5分',
    time15m: '15分',
    time30m: '30分',
    time1h: '1小时',
    timeDay: '一天'
  },

  // 服务相关
  service: {
    title: '在线客服',
    contactService: '联系客服',
    anyQuestion: '如有任何问题，请联系在线客服'
  },

  // 着陆页
  landing: {
    onlineAccount: '网上开户',
    spotGoods: '现货商品',
    contactService: '联系客服',
    personalCenter: '个人中心',
    characteristicService: '特色服务',
    characteristicServiceEn: 'CHARACTERISTIC SERVICE'
  },

  // 账户详情
  accountDetail: {
    title: '我的账户',
    totalAssets: '账户总资产',
    profitLoss: '账户盈亏',
    position: '持仓金额',
    availableFunds: '可用资金',
    refresh: '刷新',
    rechargeRecord: '充值记录',
    rechargeApply: '充值申请',
    withdrawApply: '提现申请',
    currentEntrust: '当前委托',
    historyEntrust: '历史委托',
    bill: '账单',
    bankCardManage: '银行卡管理',
    accountSecurity: '账户安全'
  },

  // 历史委托
  historyEntrust: {
    title: '历史委托',
    noRecord: '暂无记录',
    buyRise: '买涨',
    buyFall: '买跌'
  },

  // 设置相关
  settings: {
    accountSecurity: '账户安全',
    username: '用户名',
    modifyLoginPwd: '修改登录密码',
    modifyPayPwd: '修改支付密码'
  }
}
